// eslint-disable-next-line
import React, { Component } from "react";

export default class LayoutMinimalMUI extends Component {
  render() {
    return this.props.children;
  }
}